/*
 * Cookie consent banner.
 *
 * Shopify's own banner cannot be restyled beyond light/dark, and its three
 * buttons are fixed, so this replaces it. Shopify's native banner must be
 * removed in Settings > Customer privacy, or both will show.
 *
 * Everything goes through Shopify's Customer Privacy API, which is what
 * actually gates the pixels. Nothing here blocks or allows a script by
 * itself — setTrackingConsent does that, and Shopify's web pixel sandbox
 * reads the result.
 */

(function () {
  const root = document.querySelector('[data-wake-consent]');
  if (!root) return;

  const panels = {
    main: root.querySelector('[data-wake-consent-panel="main"]'),
    manage: root.querySelector('[data-wake-consent-panel="manage"]'),
  };

  const ALL = { analytics: true, marketing: true, preferences: true, sale_of_data: true };
  const NONE = { analytics: false, marketing: false, preferences: false, sale_of_data: false };

  let api = null;
  /* The API resolves after the page is interactive, so a visitor can open
     this from the footer before it arrives. Without this flag the callback
     would land afterwards and throw them back to the first panel. */
  let opened = false;

  function show() {
    opened = true;
    root.hidden = false;
    document.documentElement.classList.add('wake-consent-open');
    const first = panels.main.querySelector('button');
    if (first) first.focus();
  }

  function hide() {
    root.hidden = true;
    document.documentElement.classList.remove('wake-consent-open');
  }

  function panel(name) {
    panels.main.hidden = name !== 'main';
    panels.manage.hidden = name !== 'manage';
    const target = panels[name].querySelector('button, input');
    if (target) target.focus();
  }

  /* The callback fires whether or not the write succeeded. Hiding regardless
     is deliberate: a visitor who has answered should not be asked twice
     because a network call failed. */
  function save(consent) {
    if (!api) return hide();
    try {
      api.setTrackingConsent(consent, hide);
    } catch (e) {
      hide();
    }
  }

  function readToggles() {
    const value = Object.assign({}, NONE);
    root.querySelectorAll('[data-wake-consent-toggle]').forEach(function (input) {
      value[input.dataset.wakeConsentToggle] = input.checked;
    });
    /* Denmark does not need a separate sale-of-data choice, so it follows
       marketing rather than appearing as a fourth switch nobody understands. */
    value.sale_of_data = value.marketing;
    return value;
  }

  function syncToggles() {
    if (!api) return;
    const current = api.currentVisitorConsent() || {};
    root.querySelectorAll('[data-wake-consent-toggle]').forEach(function (input) {
      input.checked = current[input.dataset.wakeConsentToggle] === 'yes';
    });
  }

  /* shouldShowBanner() alone is not enough: it stays true after a visitor has
     answered, so on its own it would ask again on every page. The stored
     consent is the honest test of whether they have decided — an empty string
     is undecided, "yes" and "no" are both answers. */
  function hasDecided() {
    if (!api) return false;
    const current = api.currentVisitorConsent() || {};
    return ['analytics', 'marketing', 'preferences'].some(function (key) {
      return current[key] === 'yes' || current[key] === 'no';
    });
  }

  root.addEventListener('click', function (event) {
    const action = event.target.closest('[data-wake-consent-action]');
    if (!action) return;
    event.preventDefault();

    switch (action.dataset.wakeConsentAction) {
      case 'accept':
        save(ALL);
        break;
      case 'reject':
        save(NONE);
        break;
      case 'save':
        save(readToggles());
        break;
      case 'manage':
        panel('manage');
        break;
      case 'back':
        panel('main');
        break;
    }
  });

  /* Anything on the page can reopen this, which is what the footer link uses.
     Reopening starts on the manage panel, because someone who comes back is
     changing a decision rather than making one. */
  document.addEventListener('click', function (event) {
    if (!event.target.closest('[data-wake-consent-open]')) return;
    event.preventDefault();
    syncToggles();
    panel('manage');
    show();
  });

  window.Shopify.loadFeatures(
    [{ name: 'consent-tracking-api', version: '0.1' }],
    function (error) {
      if (error) return;
      api = window.Shopify.customerPrivacy;
      if (opened) return syncToggles();
      /* shouldShowBanner() answers whether consent is required in this
         visitor's region. Whether they have already answered is a separate
         question, and both have to be true to ask. */
      if (api.shouldShowBanner() && !hasDecided()) {
        panel('main');
        show();
      }
    }
  );
})();
